/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Edit_BoldInputs */

const en_forms_rule_sets_edit_bold = /** @type {(inputs: Forms_Rule_Sets_Edit_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold`)
};

const de_forms_rule_sets_edit_bold = /** @type {(inputs: Forms_Rule_Sets_Edit_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fett`)
};

/**
* | output |
* | --- |
* | "Bold" |
*
* @param {Forms_Rule_Sets_Edit_BoldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_edit_bold = /** @type {((inputs?: Forms_Rule_Sets_Edit_BoldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Edit_BoldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_edit_bold(inputs)
	return de_forms_rule_sets_edit_bold(inputs)
});